import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ClockIcon, PlaneIcon, ArrowRightIcon, CheckCircleIcon, StarIcon } from 'lucide-react';
import Button from '../common/Button';
import { Flight } from '../../utils/types';
interface FlightCardProps {
  flight: Flight;
}
const FlightCard: React.FC<FlightCardProps> = ({
  flight
}) => {
  const navigate = useNavigate();
  // Format the departure and arrival times
  const formatTime = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  };
  // Format the date
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };
  const handleSelect = () => {
    navigate(`/booking/select?flightId=${flight.id}`);
  };
  return <div className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200 hover:shadow-lg transition-shadow" data-id="element-288">
      <div className="p-6" data-id="element-289">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-4" data-id="element-290">
          <div className="flex items-center mb-2 md:mb-0" data-id="element-291">
            <div className="bg-gray-100 rounded-full p-2 mr-3" data-id="element-292">
              <PlaneIcon className="h-6 w-6 text-blue-600" data-id="element-293" />
            </div>
            <div data-id="element-294">
              <h3 className="font-medium text-gray-900" data-id="element-295">{flight.airline}</h3>
              <p className="text-sm text-gray-500" data-id="element-296">
                Flight {flight.flightNumber}
              </p>
            </div>
          </div>
          <div className="flex items-center" data-id="element-297">
            {flight.refundable && <div className="bg-green-50 text-green-700 px-3 py-1 rounded-full text-xs flex items-center mr-2" data-id="element-298">
                <CheckCircleIcon className="h-3 w-3 mr-1" data-id="element-299" />
                Refundable
              </div>}
            <div className="bg-blue-50 text-blue-700 px-3 py-1 rounded-full text-xs" data-id="element-300">
              {flight.cabinClass}
            </div>
          </div>
        </div>
        <div className="flex flex-col md:flex-row justify-between items-center mb-6 space-y-4 md:space-y-0" data-id="element-301">
          <div className="flex flex-col items-center md:items-start" data-id="element-302">
            <span className="text-2xl font-bold text-gray-900" data-id="element-303">
              {formatTime(flight.departureTime)}
            </span>
            <span className="text-sm text-gray-500" data-id="element-304">
              {formatDate(flight.departureTime)}
            </span>
            <span className="text-sm font-medium text-gray-700" data-id="element-305">
              {flight.departureCity} ({flight.departureAirport})
            </span>
          </div>
          <div className="flex flex-col items-center" data-id="element-306">
            <div className="relative" data-id="element-307">
              <div className="h-0.5 w-24 md:w-48 bg-gray-300" data-id="element-308"></div>
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white p-1" data-id="element-309">
                <ArrowRightIcon className="h-4 w-4 text-gray-400" data-id="element-310" />
              </div>
            </div>
            <div className="flex items-center mt-2 text-xs text-gray-500" data-id="element-311">
              <ClockIcon className="h-3 w-3 mr-1" data-id="element-312" />
              {flight.duration}
              {flight.stops > 0 && <span className="ml-2 text-orange-600" data-id="element-313">
                  • {flight.stops} stop{flight.stops > 1 ? 's' : ''}
                </span>}
            </div>
          </div>
          <div className="flex flex-col items-center md:items-end" data-id="element-314">
            <span className="text-2xl font-bold text-gray-900" data-id="element-315">
              {formatTime(flight.arrivalTime)}
            </span>
            <span className="text-sm text-gray-500" data-id="element-316">
              {formatDate(flight.arrivalTime)}
            </span>
            <span className="text-sm font-medium text-gray-700" data-id="element-317">
              {flight.arrivalCity} ({flight.arrivalAirport})
            </span>
          </div>
        </div>
        <div className="flex flex-col md:flex-row justify-between items-center pt-4 border-t border-gray-200" data-id="element-318">
          <div className="mb-4 md:mb-0" data-id="element-319">
            <span className="text-2xl font-bold text-blue-600" data-id="element-320">
              ${flight.price}
            </span>
            <span className="text-gray-500 text-sm ml-1" data-id="element-321">per person</span>
          </div>
          <Button variant="primary" onClick={handleSelect} data-id="element-322">
            Select Flight
          </Button>
        </div>
      </div>
    </div>;
};
export default FlightCard;